import artwork1 from "../images/Projects/Untitled-1.png";
import artwork2 from "../images/Projects/Untitled-2.png";
import artwork3 from "../images/Projects/Untitled-3.png";
import artwork4 from "../images/Projects/Untitled-4.png";
import artwork5 from "../images/Projects/Untitled-5.png";
import artwork6 from "../images/Projects/Untitled-6.png";
import artwork7 from "../images/Projects/Untitled-7.png";
import artwork8 from "../images/Projects/Untitled-8.png";

const projects = [
  {
    image: artwork1,
    description: "",
  },
  {
    image: artwork2,
    description: "",
  },
  {
    image: artwork3,
    description: "",
  },
  {
    image: artwork4,
    description: "",
  },
  {
    image: artwork5,
    description: "",
  },
  {
    image: artwork6,
    description: "",
  },
  {
    image: artwork7,
    description: "",
  },
  {
    image: artwork8,
    description: "",
  },
];

export default projects;
